import { render } from "./SkinStories.vue?vue&type=template&id=3fb1d0f6"
import script from "./SkinStories.vue?vue&type=script&lang=js"
export * from "./SkinStories.vue?vue&type=script&lang=js"

import exportComponent from "/home/mihai/repos/skinscience/skinatlas/src/clientapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__